<template>
	<div class="setting_select">
		<span class="schedule_kinds" :style="style"></span>
		<span class="ico_cafe ico_arrow"></span>
		<label for="category-select" class="txt_selected">{{_selectedCategory.name}}</label>
		<select id="category-select" title="캘린더보기" class="select_calendar" @change="onCategoryChange">
			<category v-for="category in categories"
				:id="category.categoryId" :name="category.name"
				:selected="selectedCategory === category.categoryId"></category>
		</select>
	</div>
</template>

<script>
	import { mapState, mapMutations } from 'vuex';

	import Category from './Category.vue';

	export default {
		components: {
			Category,
		},

		computed: {
			...mapState(['categories', 'selectedCategory']),
			_selectedCategory() {
				return this.categories.find(v => v.categoryId === this.selectedCategory);
			},
			style: function () {
				const color = this._selectedCategory.color;
				return {
					backgroundColor: color,
					borderColor: color,
				};
			}
		},

		methods: {
			...mapMutations(['changeCategory']),
			onCategoryChange(e) {
				this.changeCategory(parseInt(e.target.value));
			},
		},
		created: function() {
			$(window).on("orientationchange", () => {
				window.setTimeout(() => {
					$('#category-select').blur();
				}, 300);
			});
		}
	}
</script>
